var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pie-chart"},[_c('GChart',{ref:"gchart",attrs:{"type":"PieChart","data":_vm.chartData,"options":_vm.chartOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }